import * as yup from 'yup';

export const vaccineSchema = yup.object({
    name: yup.string().label('name').required('Este campo es requerido'),
});

export type vaccineSchemaType = yup.InferType<typeof vaccineSchema>
